import script from "./PlanNew.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanNew.vue?vue&type=script&setup=true&lang=js"

import "./PlanNew.vue?vue&type=style&index=0&id=13afd82e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13afd82e"]])

export default __exports__